import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-tooltip', 'open', 'Open tooltip');
Labels.set('ui-tooltip', 'close', 'Close tooltip');
